import * as XLSX from 'xlsx';

export const exportTListResidentExcel = (filteredFactures) => {

    console.log("filteredFacturesssssssssssssssssssssssss",filteredFactures);
    const toExcelDate = (date) => {
        if (!(date instanceof Date)) return null;
        const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        return Math.floor((date - excelEpoch) / (1000 * 60 * 60 * 24));
    };
    const exportData = filteredFactures.flatMap((facture) => {
        const { clients } = facture;
        const numberOfClients = clients.length;
        return clients.map((client, clientIndex) => {
            const سعر_الشراء = facture.montantAchat;
            const المبلغ_المطلوب = facture.solde;
            const تاريخ_الخروج = toExcelDate(new Date(client.clientCheckOut));
            const تاريخ_الدخول = toExcelDate(new Date(client.clientCheckIn));
            const  اسم_العميل = client.clientName;
            const جواز_السفر = client.passport; 
            const معرف_الفاتورة = facture.id_facture;
            const عدد_الفواتير = facture.nbrfact;
            const النزل = facture.selectedHotel;
            const المؤسسة = facture.selectedorganisme;
            const التاريخ = toExcelDate(new Date(facture.currentDate));
            const mergeEColumn1 = (index) => {
                if (index === 0) {
                    return {
                        سعر_الشراء,
                    };
                }
                return {
                    سعر_الشراء: "",
                };
            };

            const mergeEColumn = (index) => {
                if (index === 0) {
                    return {
                        المبلغ_المطلوب,
                    };
                }
                return {
                    المبلغ_المطلوب: "",
                };
            };
            
            return {
                ...mergeEColumn1(clientIndex),
                ...mergeEColumn(clientIndex),
                تاريخ_الخروج,
                تاريخ_الدخول,
                اسم_العميل,
                جواز_السفر,
                معرف_الفاتورة,
                عدد_الفواتير,
                النزل,
                المؤسسة,
                التاريخ,
            };
        });
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const numberColumns = ['A,B']; 
    numberColumns.forEach((column) => {
        for (let i = 1; i <= exportData.length; i++) {
            const cellAddress = XLSX.utils.encode_cell({ r: i, c: column.charCodeAt(0) - 65 });
            if (ws[cellAddress]) {
                ws[cellAddress].z = '#,##0.00'; 
            }
        }
    });
    const dateColumns = ['C', 'J', 'D'];
    dateColumns.forEach((column) => {
        for (let i = 1; i <= exportData.length; i++) {
            const cellAddress = XLSX.utils.encode_cell({ r: i, c: column.charCodeAt(0) - 65 });
            if (ws[cellAddress]) {
                ws[cellAddress].z = 'dd/mm/yyyy'; 
            }
        }
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "قائمة العملاء");
    XLSX.writeFile(wb, "قائمة العملاء.xlsx");
};
